import { Command, DrugClassData } from '../interfaces';

/**
 * Filter based on the drug class - medicine type.
 * @param data a treatment
 * @returns DrugClassData[]
 */
export const drugClassFilter = <T extends DrugClassData>(data: T[], keys: string[]) =>
    data.filter((element) => element.drugClass.some((element) => keys.includes(element.title)));

export class DrugClassFilterCommand implements Command {
    isAndFilter(): boolean {
        return true;
    }

    execute(data: DrugClassData[], keys: string[]) {
        return drugClassFilter(data, keys);
    }
}
